import React, { useEffect, useState } from "react";
import SkinSolutionComponent from "../../components/skin-solution/SkinSolutionComponent";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { getSkinSolutionApi } from "../../services/skinSolution.service";
import PageLoader from "../../components/common/loader/pageLoader";

interface SkinSolutionContainerInterface {}

const SkinSolutionContainer: React.FC<SkinSolutionContainerInterface> = () => {
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  useEffect(() => {
    setLoading(true);
    fetchSkinSolutionData();
  }, []);

  const fetchSkinSolutionData = () => {
    dispatch(
      getSkinSolutionApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data?: any) => {
          setData(data);
        },
        unAunthenticatedCallback: () => {},
      })
    );
  };

  if (loading) {
    return <PageLoader />;
  }

  return <SkinSolutionComponent data={data} />;
};

export default SkinSolutionContainer;
